import axios, { AUTH_PREFIX } from 'src/clients/axios';
import {
  ResendVerificationEmailGetRqData,
  ResendVerificationEmailGetRsData,
} from 'src/models/Client';

export const resendVerificationEmail = (
  data: ResendVerificationEmailGetRqData,
) => {
  return axios.get<ResendVerificationEmailGetRsData>(
    `${AUTH_PREFIX}/account/resend-verification-email`,
    { params: data },
  );
};
